import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  FiltersAppliedBadge,
  BadgeCount,
  FilterTitle,
} from "../flywheelIncidents/incidents.styled";

import * as React from 'react';
import Menu from '@mui/material/Menu';
import CasesFilterIcon from "assets/CasesFilterIcon";
import CustomSort from "core/components/global/customSort/customSort";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DateRangePicker from "core/components/global/dateRangePicker/dateRangePicker";
import SeveritySelect from "core/components/global/severitySelect/severitySelect";
import { CustomButtonContainer } from "core/components/global/buttons/button/customButton.styled";
import HomeToolbar from "core/components/global/homeToolbar/homeToolbar";
import { Filters1, Filters2 } from "core/components/global/homeToolbar/homeToolbar.styles";
import { getIncidentFilters } from "modules/flywheel/services/incidentService";

interface FiltersProps {
  filterData: any;
  setIsFilterModalOpen: (boolean) => void;
  deleteFilter: (arg1: string, arg2: string) => void;
  setFilterData: any;
}

function Filters({filterData, setIsFilterModalOpen, deleteFilter, setFilterData}: FiltersProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <HomeToolbar>
      <Filters1>
          <CustomButtonContainer
              variant="outlined"
              id="active-filter-menu-toggle"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClickListItem}
              disabled={Object.entries(filterData["filterTerms"]).length > 0 || filterData["searchTerm"] !== "" ? false : true}
            >

              <FilterTitle className="pe-2 d-flex">{t("INCIDENTS_PAGE.FILTERSAPPLIED")}</FilterTitle>
              <FiltersAppliedBadge>
                <BadgeCount>{filterData.totalFilters}</BadgeCount>
              </FiltersAppliedBadge>
          </CustomButtonContainer>
          <Menu
            id="active-filter-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            sx={{padding: "0"}}
          >
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="left" variant="head">Column</TableCell>
                    <TableCell align="left" variant="head">Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <>
                    {Object.entries(filterData["filterTerms"]).map(([category, categoryValue]: [string, string], index: number) => (
                      // Check if the category is not "filter[assignedto]" before rendering
                      category !== "filter[assignedto]" && (
                        typeof categoryValue === 'string' && categoryValue.includes(",") ? (
                          categoryValue.split(',').map((value, valueIndex) => (
                            <TableRow key={`${category}-${valueIndex}`}>
                              <TableCell component="th" scope="row">
                                <CloseIcon onClick={() => deleteFilter(category, value)}/>
                              </TableCell>
                              <TableCell align="left">{category}</TableCell>
                              <TableCell align="left">{value.trim()}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              <CloseIcon onClick={() => deleteFilter(category, categoryValue)}/>
                            </TableCell>
                            <TableCell align="left">{category}</TableCell>
                            <TableCell align="left">{String(categoryValue)}</TableCell>
                          </TableRow>
                        )
                      )
                    ))}
                  </>
                </TableBody>
              </Table>
          </Menu>
          <SeveritySelect setFilterData={setFilterData}/>
      </Filters1>

      <Filters2>
        <DateRangePicker setFilteredData={setFilterData} />
        <CustomButtonContainer
          variant="outlined"
          data-testid="filter-btn"
          className="all-filters"
          onClick={() => setIsFilterModalOpen(true)}
        >
          {t("INCIDENTS_PAGE.ALLFILTERS")}
          <CasesFilterIcon />
        </CustomButtonContainer>
      </Filters2>
    </HomeToolbar>
  );
}

function AnalystToolbar({headCells, setFilterData, isFilterModalOpen, setIsFilterModalOpen, setPage, filterData, deleteFilter}: any) {
  return (
    <>
        <Filters
            filterData={filterData}
            setIsFilterModalOpen={setIsFilterModalOpen}
            deleteFilter={deleteFilter}
            setFilterData={setFilterData}
        />
        <CustomSort 
            table_headers={headCells} 
            setFilterData={setFilterData}
            isFilterModalOpen={isFilterModalOpen || false}
            setIsFilterModalOpen={setIsFilterModalOpen}
            setPage={setPage}
            getFiltersFunction={getIncidentFilters}
        />
    </>
  );
}

export default memo(AnalystToolbar);